/*
 * Free Shipping Progress Bar
 * Dynamically updates the shipping bar when cart changes
 */
(function() {
  'use strict';

  var FreeShippingBar = {
    bar: null,
    textEl: null,
    progressEl: null,
    threshold: 0,
    messageTemplate: '',
    successMessage: '',

    init: function() {
      this.bar = document.getElementById('FreeShippingBar');
      if (!this.bar) return;

      this.textEl = this.bar.querySelector('[data-free-shipping-text]');
      this.progressEl = this.bar.querySelector('[data-free-shipping-progress]');
      this.threshold = parseInt(this.bar.dataset.threshold, 10);
      this.messageTemplate = this.bar.dataset.message;
      this.successMessage = this.bar.dataset.successMessage;

      this.bindEvents();
    },

    bindEvents: function() {
      var self = this;

      // MutationObserver auf das Subtotal-Element
      var subtotalEl = document.querySelector('[data-subtotal]');
      if (subtotalEl) {
        var observer = new MutationObserver(function() {
          self.fetchAndUpdate();
        });
        observer.observe(subtotalEl, { childList: true, characterData: true, subtree: true });
      }

      // Cart-Events des Themes abfangen
      document.addEventListener('cart:updated', function() {
        self.fetchAndUpdate();
      });

      // Drawer öffnen/schließen beobachten
      var drawer = document.getElementById('CartDrawer');
      if (drawer) {
        var drawerObserver = new MutationObserver(function() {
          if (drawer.classList.contains('is-open') || drawer.classList.contains('drawer--open')) {
            self.fetchAndUpdate();
          }
        });
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }

      // Regelmäßig prüfen wenn Drawer sichtbar ist
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-cart-toggle], .js-cart-toggle, .site-header__cart, [href="/cart"]')) {
          setTimeout(function() { self.fetchAndUpdate(); }, 500);
        }
        if (e.target.closest('.js-add-to-cart, [data-add-to-cart], .add-to-cart')) {
          setTimeout(function() { self.fetchAndUpdate(); }, 1000);
        }
      });
    },

    fetchAndUpdate: function() {
      var self = this;
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          self.update(cart.total_price);
        })
        .catch(function(err) {
          console.warn('Free shipping bar: Could not fetch cart', err);
        });
    },

    update: function(totalPriceCents) {
      if (!this.bar || !this.textEl || !this.progressEl) return;

      var percentage = Math.min((totalPriceCents / this.threshold) * 100, 100);
      this.progressEl.style.width = percentage + '%';

      if (totalPriceCents >= this.threshold) {
        this.textEl.innerHTML = this.successMessage;
        this.bar.classList.add('is-reached');
      } else {
        var remainingCents = this.threshold - totalPriceCents;
        var remainingFormatted = this.formatMoney(remainingCents);
        this.textEl.innerHTML = this.messageTemplate.replace('{{ amount }}', remainingFormatted);
        this.bar.classList.remove('is-reached');
      }
    },

    formatMoney: function(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' €';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      FreeShippingBar.init();
    });
  } else {
    FreeShippingBar.init();
  }
})();